import React from "react";
import styled from "styled-components";
import { StateManager } from "../../../rule-engine-core/Common/StateManager";

import { TreeRuleNodeProps } from "./XTreeRuleNode";
import { Connector } from "./Connector";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

export const MissingRuleNode = ({ node, ruleDefinition }: TreeRuleNodeProps) => {
    const updateCallback = () => {
        StateManager.changed(node);
        StateManager.changed(ruleDefinition);
    };

    const onSetExpression = () => {
        node.setupEvaluation(ruleDefinition.getInputDefinition());
        updateCallback();
    };

    const onSetResult = () => {
        node.setupResult(ruleDefinition.getInputDefinition(), ruleDefinition.getRuleResult());
        updateCallback();
    };

    if (ruleDefinition.root === node) {
        return <RootEmptyRuleNodeRender onClick={onSetExpression}>Add Expression</RootEmptyRuleNodeRender>;
    }

    return (
        <Wrapper id={node._id}>
            <MissingRuleNodeRender>
                <MissingRuleNodeButton onClick={onSetResult}>Result</MissingRuleNodeButton>
                <MissingRuleNodeButton onClick={onSetExpression}>Expression</MissingRuleNodeButton>
            </MissingRuleNodeRender>
            <Connector nodeid={node._id} />
        </Wrapper>
    );
};

const MissingRuleNodeRender = styled.div`
    padding: 8px;
    border: 1px dashed ${UIStyleConstants.GRAY_LIGHTER_COLOR};
    border-radius: 4px;

    display: flex;

    > * {
        margin-left: 8px;

        &:first-child {
            margin-left: 0px;
        }
    }
`;

const MissingRuleNodeButton = styled.div`
    background: ${UIStyleConstants.GRAY_LIGHT_COLOR};

    color: ${UIStyleConstants.BLUE_COLOR};

    box-shadow: 0px 2px 4px -2px ${UIStyleConstants.GRAY_COLOR};
    border-radius: 4px;

    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: center;

    padding: 5px 12px;

    cursor: pointer;

    &:hover {
        background: linear-gradient(
                0deg,
                ${UIStyleConstants.GRAY_LIGHTER_COLOR},
                ${UIStyleConstants.GRAY_LIGHTER_COLOR}
            ),
            ${UIStyleConstants.GRAY_LIGHTER_COLOR};
    }
`;

const RootEmptyRuleNodeRender = styled.div`
    background: ${UIStyleConstants.BLUE_COLOR};
    border-radius: 4px;

    padding: 13px 20px;

    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 17px;
    letter-spacing: 0px;
    text-align: center;

    color: ${UIStyleConstants.WHITE_COLOR};
    cursor: pointer;

    max-width: 131px;

    &:hover {
        background: linear-gradient(0deg, ${UIStyleConstants.BLUE_COLOR}, ${UIStyleConstants.BLUE_COLOR}),
            ${UIStyleConstants.WHITE_COLOR};
    }
`;

const Wrapper = styled.div`
    padding: 4px;
    position: relative;
    border: 2px solid transparent;
`;
